import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { tap, finalize } from 'rxjs/operators';
import { SpinnerService } from '../_services/spinner.service';

@Injectable({
	providedIn: 'root'
})
export class LoadingSpinnerInterceptorService implements HttpInterceptor {

	private numRequests: number = 0;
	private showLoading: boolean;
	private spinnerService: SpinnerService;

	constructor(private injector: Injector) {
		this.spinnerService = this.injector.get(SpinnerService);
	}

	intercept(req: HttpRequest<any>, next: HttpHandler):
		Observable<HttpEvent<any>> {
		this.turnOnModal();
		var that = this;
		return next.handle(req).pipe(finalize(() => { that.turnOffModal(); }));
	};

	private turnOnModal() {
		this.numRequests++;
		if (!this.showLoading) {
			this.showLoading = true;
			this.spinnerService.block();
		}
	}

	private turnOffModal() {
		this.numRequests--;
		if (this.numRequests <= 0 && this.showLoading) {
			this.showLoading = false;
			this.spinnerService.unblock();
		}
	}
}
